import { ActivatedRoute, Router, UrlSerializer } from '@angular/router';
import { Component, OnInit, ElementRef } from '@angular/core';

import { RecuperarSenhaService } from './../../../../shared/services/auth/recuperar-senha/recuperar-senha.service';
import { takeUntil } from 'rxjs/operators';
import { ICheckStatus } from '../../../../shared/services/auth/recuperar-senha/recuperar-senha.interface';
import { Subject } from 'rxjs';
import swal from 'sweetalert2';

@Component({
  selector: 'app-recuperar-senha',
  templateUrl: './recuperar-senha.component.html',
  styleUrls: ['./recuperar-senha.component.scss']
})
export class RecuperarSenhaComponent implements OnInit {
  public email = '';
  public unsubscriber = new Subject();
  public responseMessage = '';

  public error = false;
  public success = false;

  constructor(
    private router: Router,
    private elRef: ElementRef,
    private route: ActivatedRoute,
    private recuperarSenhaService: RecuperarSenhaService,
    private urlSerializer: UrlSerializer,
  ) { }

  ngOnInit() {
    this.getParameters();
  }

  getParameters() {
    this.email = this.route.snapshot.params['email'] ? this.route.snapshot.params['email'] : this.email;
  }

  sendPasswordRecovery() {
    this.error = false;
    this.success = false;
    this.enableLoading();

    if (!this.isEmail(this.email)) {
      this.responseMessage = 'O campo E-mail é obrigatório';
      this.error = true;
      this.disableLoading();
      return;
    }


    this.recuperarSenhaService.checkStatus(this.email).pipe(takeUntil(this.unsubscriber)).subscribe((res: ICheckStatus) => {
      if (!res) {
        this.disableLoading();
        return swal( 'Erro!', 'Conta não encontrada');
      }

      if (res && !res.EmailConfirmed) {
        this.disableLoading();
        return;
      }

      return this.sendEmailResetPassowrd(this.email);
    }, error => {
      console.error(error);
      this.disableLoading();
    });
  }

  
  public sendEmailResetPassowrd(email: string): void {
    const base64 = btoa(JSON.stringify({Email: email, Code: null}));
    this.recuperarSenhaService.sendEmailResetPassword(email).pipe(takeUntil(this.unsubscriber)).subscribe((response) => {
      const tree = this.router.createUrlTree(['/login/email-confirmation'], {
        queryParams: { token: base64 },
        queryParamsHandling: 'merge',
      });
      const url = this.urlSerializer.serialize(tree);
      this.router.navigateByUrl(url);
      this.disableLoading();
    }, (error) => {
      console.error(error);
      swal('Ocorreu um erro.');
      this.disableLoading();
    });
  }

  isEmail(email) {
    return email ? true : false;
  }

  showRequestErrorMessages(err) {
    if (err && err.error && err.error.ModelState && err.error.ModelState.Erros && err.error.ModelState.Erros.length > 0) {
      this.responseMessage = err.error.ModelState.Erros[0];
    } else {
      this.responseMessage = 'Não foi possível enviar a solicitação. Tente novamente mais tarde.';
    }
  }

  goToLogin() {
    this.email ? this.router.navigate(['/login/' + this.email]) : this.router.navigate(['/login/']);
  }

  enableLoading() {
    this.elRef.nativeElement.querySelector('.btn-registrar').classList.add('loading');
    this.elRef.nativeElement.querySelector('.btn-registrar').style.opacity = '1';
  }

  disableLoading() {
    this.elRef.nativeElement.querySelector('.btn-registrar').classList.remove('loading');
  }

  ngOnDestroy(): void {
    this.unsubscriber.next();
    this.unsubscriber.complete();
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/auth/components/recuperar-senha/recuperar-senha.component.ts